module.exports = __webpack_public_path__ + "static/media/IMG_0373_Reduced.70c75c3a.jpg";